export default __webpack_public_path__ + "cd5e231e0cc53b2cb2c029b09b917782.woff2";